<app-host-details
  #hostDetails
  [host]="host()"
  [allActivities]="activities()"
  [isPublic]="true"
  [isPreview]="false">
</app-host-details>

<app-responsive-buttons #bottomButtons>
  <button type="button" class="btn btn-light text-uppercase" (click)="close()">
    Fermer
  </button>
  <button type="button" class="btn btn-light text-uppercase" (click)="share()">
    <lucide-icon [img]="icons.share"></lucide-icon>
  </button>
  <button type="button" class="btn btn-primary text-uppercase"
          (click)="hostDetails.toggleShowContact()">Contacter
  </button>
</app-responsive-buttons>
